export const PERFIL = 'Perfil'

export const SAIR = 'Sair'
